import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";
import type { AgreementWarning } from "./agreementData";

// Warnings of an agreement (D-031: nothing blocks, the page tells)
export const AgreementWarnings = ({
  warnings,
}: {
  warnings: AgreementWarning[];
}) => {
  const translate = useTranslate();
  if (!warnings.length) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {warnings.map((warning) => (
        <Badge key={warning} variant="destructive">
          {translate(`tenax.agreements.warning.${warning}`)}
        </Badge>
      ))}
    </div>
  );
};
